import { apiGet, apiPost, API_URI, CRM_API_URI } from "api";

const clients = {
  getAll: async () => {
    const data = apiGet(`${API_URI}/api/client/getall`);
    return data;
  },
  insertClient: async (client: any) => {
    const data = apiPost(`${CRM_API_URI}/api/clientcontact/save`, client);
    return data;
  },
  getAllProducts: async (clientId: number) => {
    const data = apiPost(`${CRM_API_URI}/api/client/products/${clientId}`);
    return data;
  },
};

export default clients;
